import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

import {
  FROMDT_GT_TODT,
  NonCompliance,
  STARTDT_GT_ENDDT,
  Task,
  WpEtEnrollment,
  WpNonCompliance, WpPerson,
  WpReferral
} from '../shared';
import { CommonUtility, DateUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { REQUIRED_FIELD, SELECT_A_VALUE , Date_NOT_SELECTED } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import {DashboardType} from "../shared/model/dashboardType";
import {Role} from "../shared/model/role.model";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {EnrollmentSumary} from "../shared/model/EnrollmentSumary";
import {CommonServicesRequest} from "../shared/model/CommonServicesRequest";
import {PersonProvider} from "../shared/model/PersonProvider";
import { TaskAdditionalInfo } from '../shared/task-additional-info.model';


@Component({
  selector: 'app-non-compliance',
  templateUrl: './non-compliance.component.html',
  styleUrls: ['./non-compliance.component.scss']
})
export class NonComplianceComponent implements OnInit, CanComponentDeactivate {
  referralId: string = '';
  personId: string = '';
  // providerId: string = '';
  nonCoopId: string='';
  wpEtEnrollment: WpEtEnrollment;
  wpNonCompliance:WpNonCompliance;
  wpNonComplainceCpy: WpNonCompliance;

  nonCompliance: NonCompliance;
  nonCompliancePrev: NonCompliance;
  nonComplianceClone: NonCompliance;
  errorRadioConcilliation:Boolean = false;
  errorRadioGoodCause:Boolean = false;
  errorDateField: Boolean = false;

  successMessage: string;
  errorMessage: string;
  requiredFieldMsg: string;
  selectFieldMsg: string;
  errorReasonCd: Boolean = false;
  userActionNotificationsMap: any;
  nonComplianceReasonDesc: any[];
  nonComplianceReasonDescMap: any;
  verificationMap: any;

  ServerConstants: any;
  refData: any;
  programs: any;
  participationFailed: any;
  reasons: any;
  verification: any;
  sharedData: any;

  errorEndDateField: string = null;
  providerId: any;
  roles: Role[];


  isNCDisabled: any;
  isGCVisible: any;
  isSaveDisabled: any = false;
  isResetDisable: Boolean = false;
  displayInCompliance: Boolean = false;
  
  isWorker: Boolean = true;

  user: any;
  gcNotesSize: number = 0;
  ncNotesSize: number = 0;

  minDDDate: NgbDateStruct;
  maxDDDate: NgbDateStruct;
  minNCDate: NgbDateStruct;
  maxNCDate: NgbDateStruct;
  todayDate: Date;

  monthDate: Date;
  minMonthDate: Date;

  requestObject: Task;
  task: Task;
  cTask: Task;
  newTask: Task;
  taskAdditionalInfo:TaskAdditionalInfo;
  commonServiceRequest :CommonServicesRequest;

  personProvider: PersonProvider;
  serviceCountyForPerson: number;
  providerForPerson: number;

  provider: number;

  pageInfo: any;
  isReasonOther: boolean = false;
  isGCDisabled: boolean = false;
  isNCSeccionDisabled:boolean = false;
  isChangeDetected:boolean;
  isSystemCoordinator: boolean = false;

  nonCoopMonthDtString: string;
  nonCoopMonthDt: Date;
  requestReason:any=[];
  requestType:any = null;
  requestedBy:any = 'Provider';



  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    private data: ReferenceTableService,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('NCMPL') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = false;
    this.sharedData = this.dataService.getSharedDataObject();
    this.nonCompliance = new NonCompliance();
    this.nonCompliancePrev = new NonCompliance();

    this.wpEtEnrollment = new WpEtEnrollment();
    this.wpNonCompliance = new WpNonCompliance();
    this.wpNonComplainceCpy = new WpNonCompliance();

    this.parseRefTableData();

    /* Attach model on the main object */
    this.nonCompliance.wpEtEnrollment = this.wpEtEnrollment;
    this.nonCompliance.wpNonCompliance = this.wpNonCompliance;

    /* set global values for page */
    this.referralId = this.sharedData.get('referralId');
    this.personId = this.sharedData.get('wpPersonId');
    this.nonCoopId = this.sharedData.get('nonCoopId');
    this.providerId = this.sharedData.get('providerId');
    if(this.providerId == undefined && this.providerId == null ){
      this.requestedBy = "Worker";
    }

    this.roles = this.sharedData.get('roles');
    this.task = this.sharedData.get('taskId');
    this.personProvider = this.sharedData.get('personProvider');
    this.serviceCountyForPerson = this.personProvider.id.serviceCounty;
    this.providerForPerson = this.personProvider.id.providerId;

    this.nonCompliance.referralId = parseInt(this.referralId);
    this.nonCompliance.personId = parseInt(this.personId);
    this.nonCompliance.nonCoopId = parseInt(this.nonCoopId);


    this.nonCompliance.wpNonCompliance.referralId = parseInt(this.referralId);
    this.nonCompliance.wpNonCompliance.personId = parseInt(this.personId);

    this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd= null;

    this.validDates();
    this.userAccess();

    this.pageInfo = this.sharedData.get('NCMPL').innerNavPages.find(x=>x.pageId == "WCNCO");
    //this.pageInfoUserAccess();

    if( !isNaN(this.nonCompliance.nonCoopId)  && this.nonCompliance.nonCoopId != null ){
      this.isNCSeccionDisabled = true;
      this.nonComplianceClone = Object.assign({}, this.nonCompliance);
      this.load(this.nonCompliance );
      this.displayInCompliance=true;
    } else {
      this.displayInCompliance=false;
    }

    if (this.nonCompliance !== null) {
      this.nonCompliancePrev = Object.assign({}, this.nonCompliance);
    }
    
    console.log('Roles    === ' + this.roles[0].id);
    if(this.roles[0].id !==5){
      this.isResetDisable=true;
     // this.isSaveDisabled=true;
    }
    console.log(' this.isSaveDisabled    === ' +  this.isSaveDisabled);
   
  }

  userAccess(){
    this.isNCDisabled = true;
    this.isGCVisible = false;
    this.isWorker = true;

    for( const role of this.roles){
      if( role.id === 5 ){
        this.isNCDisabled = false;
        this.isGCVisible = false;
        this.isWorker = false;
      }
      else if (role.id == 1 || role.id == 2 || role.id == 3 ){
        this.isNCDisabled = true;
        this.isGCVisible = true;
      }
      if( role.id == 4 ){
        this.isNCDisabled = false;
        this.isGCVisible = true;
        this.isSystemCoordinator = true;
      }
    }
  }

  pageInfoUserAccess(){
    this.isNCDisabled = true;
    this.isGCVisible = false;

    if(this.pageInfo.readOnly === false){
      this.isNCDisabled = false;
      this.isGCVisible = false;
    }else{
      this.isNCDisabled = true;
      this.isGCVisible = true;
    }

    for( const role of this.roles) {
      if (role.id == 4) {
        this.isNCDisabled = false;
        break;
      }
    }
  }

  validDates(){
    this.todayDate= new Date();
    this.minDDDate = {
      month: this.todayDate.getMonth() - 1,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };
    this.maxDDDate = {
      month: this.todayDate.getMonth() +1,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };
    this.minNCDate = {
      month: this.todayDate.getMonth() - 2,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };
    this.maxNCDate = {
      month: this.todayDate.getMonth()+1,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };
  }

  load(nonCompliance){

    /* if( this.isSystemCoordinator){
       this.isNCDisabled = false;
     }else{
       this.isNCDisabled = true;
     }*/

    this.http.post<NonCompliance>(this.ServerConstants.NC_SERVER_API_URL + '/wp-nc-good-causes/load', nonCompliance).subscribe(
      (data: NonCompliance ) => {

        setTimeout(() => this.headerText.nativeElement.focus(), 0);
        this.headerText.nativeElement.click();

        this.nonCompliance = data;

        if(!this.nonCompliance.wpNonCompliance){
          this.nonCompliance.wpNonCompliance = {};
        }
        if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
          this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
        }
        if(this.nonCompliance.wpNonCompliance.goodCauseGrantedDt != null){
          this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = this.dateUtil.convertDateFromServer(this.nonCompliance.wpNonCompliance.goodCauseGrantedDt);
        }
        if(this.nonCompliance.wpNonCompliance.nonCoopMonthDt != null){
          this.nonCoopMonthDtString = moment(this.nonCompliance.wpNonCompliance.nonCoopMonthDt).format('MM/YYYY');
        }
        if(this.nonCompliance.wpNonCompliance.complianceDate != null){
          this.nonCompliance.wpNonCompliance.complianceDate = this.dateUtil.convertDateFromServer(this.nonCompliance.wpNonCompliance.complianceDate);
        }
        /*Good Cause Authorized*/
        if(data.wpNonCompliance['createdBy'].toLowerCase() == 'citizen'){
          this.requestedBy = "Citizen";
        }
        else{
          this.requestedBy = "Provider";
        }
        this.reasonChanged(this.nonCompliance.wpNonCompliance.nonComplianceReasonCd);


        if ( this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd !== null && this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd !== "")
        {
          this.isNCDisabled = true;
          this.isGCDisabled = true;
         // this.isSaveDisabled = true;
          this.isResetDisable = true;
        }

        if ( (this.providerId !== null)  ) {
         // this.isSaveDisabled = true;
          this.isResetDisable = true;
          this.isNCDisabled = true;
        }

      },response => {
        this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
        setTimeout(() => this.fileInput.nativeElement.focus(), 0);

      },() => {
      });
  }

  radioGoodCause(event) {
    this.errorRadioGoodCause = false;
  }

  radioConcilliation(event) {
    this.errorRadioConcilliation = false;
  }

  reset(){
    if( this.nonCompliance.wpNonCompliance.id != null){
      this.nonCompliance = this.nonComplianceClone;
      this.load(this.nonCompliance );
    }
    else {
      this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = null;
      this.nonCoopMonthDtString = null;
      this.nonCompliance.wpNonCompliance.nonComplianceReasonCd = null;
      this.nonCompliance.wpNonCompliance.programCd = null;
      this.nonCompliance.wpNonCompliance.goodCauseRequestedSw = null;
      this.nonCompliance.wpNonCompliance.nonComplianceNotes = null;
      this.nonCompliance.wpNonCompliance.grantGoodCauseCd =  null;
      this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = null;
      this.nonCompliance.wpNonCompliance.goodCauseNotes = null;
    }
  }

  dataChanges(){
    this.isResetDisable = false;
    this.isChangeDetected = true;
  }

  reasonChanged(reason){
    if(reason === 'OT'){
      this.isReasonOther = true;
    }else{
      this.isReasonOther = false;
    }
    if(reason == undefined){
      this.requestType = '';
    }
    else if(this.data.getValueFromSharedDataMap("ExemptionReasonsDesc").find(obj => obj.value == reason)){
      this.requestType = 'Exemption';
    }
    else{
      this.requestType = 'Good Cause';
    }
    console.log(this.data);
    console.log(reason);
  }

  populateDate(){
    this.todayDate= new Date();
    let grantedDate: NgbDateStruct;

    grantedDate = {
      month: this.todayDate.getMonth()+1 ,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };

    if(this.nonCompliance.wpNonCompliance.grantGoodCauseCd ==='G'){
      this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = grantedDate;
    }
    else if( this.nonCompliance.wpNonCompliance.grantGoodCauseCd ==='D'){
      this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = null;
    }else {
      this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = null;
    }

    if(this.nonCompliance.wpNonCompliance.grantGoodCauseCd != undefined){
      this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd = this.nonCompliance.wpNonCompliance.grantGoodCauseCd;
    }
    else{
      this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd = null;
    }

  }

  getSystemDateFromModel() {
    const sysDate = new Date();
    return {
      year: sysDate.getFullYear(),
      month: sysDate.getMonth() + 1,
      day: sysDate.getDate()
    };
  }

  submitnonConcilliation(){
    if(!this.errorDateField){
      this.formatDatesForserver();
      if(this.nonCompliance.wpNonCompliance.inCompliance != null && this.nonCompliance.wpNonCompliance.inCompliance != undefined) {
        this.saveNonComplianceFlag();
      } else {
        this.saveNonCompliance();
      }
      
    }
  }

  formatDatesForserver() {
    if (this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null) {
      this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateForServer(
        this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
    }

    if (this.nonCompliance.wpNonCompliance.goodCauseGrantedDt != null) {
      this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = this.dateUtil.convertDateForServer(
        this.nonCompliance.wpNonCompliance.goodCauseGrantedDt);
    }

    if(this.nonCompliance.wpNonCompliance.complianceDate != null){
      this.nonCompliance.wpNonCompliance.complianceDate = this.dateUtil.convertDateForServer(
        this.nonCompliance.wpNonCompliance.complianceDate);
    }
    
    if (this.nonCompliance.wpNonCompliance.id === undefined ||this.nonCompliance.wpNonCompliance.id === null) {
      if (this.nonCoopMonthDtString != null && this.errorDateField === false ) {
        this.nonCoopMonthDt = new Date(parseInt(this.nonCoopMonthDtString.slice(2), 0), parseInt(this.nonCoopMonthDtString.slice(0, 2), 0) - 1, 1);
        this.nonCompliance.wpNonCompliance.nonCoopMonthDt = this.dateUtil.convertObjectDateForServer(this.nonCoopMonthDt);
      }
      else {
        return false;
      }
    }
    return true;
  }

  validateMonthDate(){
    /*This method only validates from 1 year in the past to discovery date (minMonthDate)*/

    this.requiredFieldMsg= "";
    if( this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null ){

      var nonCoopDiscoveryDt = new Date( this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt.year,
        this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt.month -1,
        this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt.day );
      this.minMonthDate = new Date( this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt.year -1,
        this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt.month - 1,
        this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt.day);

      if(this.nonCoopMonthDtString.length === 6){
        var year= parseInt(this.nonCoopMonthDtString.slice(2, 6));
        var month = parseInt(this.nonCoopMonthDtString.slice(0, 2));
        var todayDate = new Date();
        this.monthDate = new Date ( year, month - 1, 1 );

        if ( year <= todayDate.getFullYear() && month <= 12 ){
          if ( this.monthDate > this.minMonthDate &&  this.monthDate <= nonCoopDiscoveryDt ){
            this.errorDateField = false;
          }
          else{
            this.errorDateField = true;
            this.requiredFieldMsg = "Invalid Date";
          }
        }else{
          this.errorDateField = true;
          this.requiredFieldMsg = "Invalid Date";
        }
      }else{
        this.errorDateField = true;
        this.requiredFieldMsg = "Invalid Date";
      }
    }
    else{
      this.errorDateField = true;
      this.requiredFieldMsg = "Select Discovery Date";
      this.nonCoopMonthDtString = null;
    }
  }

  public ncOnQuickTextChanged($event) {
    this.ncNotesSize = this.nonCompliance.wpNonCompliance.nonComplianceNotes.length;
  }
  public gcOnQuickTextChanged($event) {
    this.gcNotesSize = this.nonCompliance.wpNonCompliance.goodCauseNotes.length;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };

  saveNonCompliance(){
    this.isChangeDetected = false;
    this.modalPopupService.setChangeDetected(false);
    if(this.nonCompliance.wpNonCompliance.nonComplianceReasonCd != 'OT'){
      this.nonCompliance.wpNonCompliance.nonComplianceNotes = null;
    }

    this.http.post<NonCompliance>(this.ServerConstants.NC_SERVER_API_URL + '/wp-nc-good-causes/save', this.nonCompliance ).subscribe(
      (data: NonCompliance ) => {
        // convert date to the proper format for UI

        if( data == null || data.hasOwnProperty('errorCode')){
          this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);

          if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
            this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(
              this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
          }
        }else{
          if (data.duplicate) {
            if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
              this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(
                this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
            }
            this.notificationService.warn('Non-Compliance', 'Duplicate record exists.');
            return;
          }

          this.isNCDisabled = true;
          this.nonCompliance = data;
          this.isNCSeccionDisabled = true;

          /* Update Track Component */
          if( this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd !== null && this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd !== "" ) {
            if (this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'Y') {
              this.updateTrackComponent(this.nonCompliance.wpNonCompliance.wpEtEnrollmentId,
                this.nonCompliance.wpNonCompliance.nonCoopMonthDt,
                this.nonCompliance.wpNonCompliance.goodCauseAuthorizedCd);
            }
          }

          if( this.nonCompliance.wpNonCompliance.grantGoodCauseCd != null){
            this.isGCDisabled = true;
          }

          if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
            this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(
              this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
          }

          if(this.nonCompliance.wpNonCompliance.goodCauseGrantedDt != null){
            this.nonCompliance.wpNonCompliance.goodCauseGrantedDt = this.dateUtil.convertDateFromServer(
              this.nonCompliance.wpNonCompliance.goodCauseGrantedDt);
          }

          if(this.nonCompliance.wpNonCompliance.nonCoopMonthDt != null){
            this.nonCompliance.wpNonCompliance.nonCoopMonthDt = this.dateUtil.convertDateFromServer(
              this.nonCompliance.wpNonCompliance.nonCoopMonthDt);
          }

          if(this.nonCompliance.wpNonCompliance.id != null){
            this.notificationService.success('Non-Compliance', this.userActionNotificationsMap.UPDATE);
            if(this.requestType == 'Good Cause' && this.requestedBy == 'Provider'){
              this.createTask(data.wpNonCompliance.id);
            }
            else if(this.requestType == 'Exemption' && this.requestedBy == 'Provider'){
              this.createTask(data.wpNonCompliance.id);
            }

            else if(this.requestType != 'Good Cause' && this.requestedBy == 'Provider' && this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'N'){
              this.createTask(data.wpNonCompliance.id);
            }
            else{
             this.saveDecision('N');
            }
            if(this.nonCompliance.wpNonCompliance.grantGoodCauseCd != null || this.nonCompliance.wpNonCompliance.grantGoodCauseCd != undefined){
              this.createAlert();
            }
            setTimeout(() => this.headerText.nativeElement.focus(), 0);
            this.headerText.nativeElement.click();
            this.goToNcSummary();
          }
        }
      },
      response => {
       this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
        if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
          this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(
            this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
        }
        setTimeout(() => this.fileInput.nativeElement.focus(), 0);

      },
      () => {
      });
  }


  saveNonComplianceFlag(){
    this.isChangeDetected = false;
    this.modalPopupService.setChangeDetected(false);

console.log('update nonCompliance.wpNonCompliance.inCompliance' + this.nonCompliance.wpNonCompliance.inCompliance);
console.log('update nonCompliance.wpNonCompliance.complianceDate' + this.nonCompliance.wpNonCompliance.complianceDate);

    this.http.post<NonCompliance>(this.ServerConstants.NC_SERVER_API_URL + '/wp-nc-good-causes/updateNonCompliance', this.nonCompliance ).subscribe(
      (data: NonCompliance ) => {
      
        if( data == null || data.hasOwnProperty('errorCode')){
          if(this.nonCompliance.wpNonCompliance.inCompliance == 'Y') {
            this.notificationService.error('Non-Compliance','Unable to send notification to the eligibility system; system will retry later.');
          } else {
            this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
          }
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);
        } else{
          if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
            this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(
              this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
          }
          this.notificationService.success('Record saved successfully', this.userActionNotificationsMap.UPDATE);
          this.goToNcSummary();
        }
      },
      response => {
        if(this.nonCompliance.wpNonCompliance.inCompliance == 'Y') {
           this.notificationService.error('Non-Compliance','Unable to send notification to the eligibility system; system will retry later.');
        } else {
          this.notificationService.error('Non-Compliance', this.userActionNotificationsMap.ERROR);
        }  
        if(this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt != null){
          this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt = this.dateUtil.convertDateFromServer(
            this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt);
        }
        setTimeout(() => this.fileInput.nativeElement.focus(), 0);

      },
      () => {
      });
  }

  updateTrackComponent( etEnrrollment, monthDt, goodCauseAutorizedCd  ){
    var goodCause: GoodCauseVO;
    goodCause = new GoodCauseVO( etEnrrollment, monthDt, goodCauseAutorizedCd);
    this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/component/updateGC/', goodCause).subscribe(
      (data) => {

        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Track Component Error', this.userActionNotificationsMap.ERROR);
        }
        else{
          this.notificationService.success('Track Component', this.userActionNotificationsMap.UPDATE);
        }
      }, response => {
        this.notificationService.error('Track Component Error', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }

  completeTask(){
    this.cTask = new Task();
    this.cTask.wpPerson = new WpPerson();
    this.cTask.wpPerson.id = parseInt(this.personId);
    this.cTask.wpReferral = new WpReferral();
    this.cTask.wpReferral.id = parseInt(this.referralId);
    this.cTask.assignedToInd = 'C';
    this.cTask.programCd = this.nonCompliance.wpNonCompliance.programCd ;

    if( this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'Y' ){
      this.cTask.taskType =  'GR' ;
    }
    else if ( this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'N'){
      this.cTask.taskType =  'NC' ;
    }
    this.closeTask();
  }

  createTask(id){
    let disDate = '';
    let goodCausMonth = '';
    let today = new Date();
    let dueDate = new Date();
    dueDate.setDate( dueDate.getDate() + 10);

    this.newTask = new Task();
    this.newTask.taskAdditionalInfo = new TaskAdditionalInfo();
    
    this.newTask.wpPerson = new WpPerson();
    this.newTask.wpPerson.id = parseInt(this.personId);
    this.newTask.wpReferral = new WpReferral();
    this.newTask.wpReferral.id = parseInt(this.referralId);
    this.newTask.programCd = this.nonCompliance.wpNonCompliance.programCd ;
    this.newTask.taskStatus = 'OP'
    this.newTask.taskStartDt = this.dateUtil.convertObjectDateForServer(today);
    this.newTask.taskDueDt = this.dateUtil.convertObjectDateForServer(dueDate);
    this.newTask.parentTaskId = id;
   let monthMM: string = this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['month'];
    if ( this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['month'] < 10) {
      monthMM = '0' + this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['month'];
    }
    let dateDD: string = this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['day'];
    if ( this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['day'] < 10) {
      dateDD = '0' + this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['day'];
    }
    disDate=this.nonCompliance.wpNonCompliance.nonCoopDiscoveryDt['year'] + '-'+ monthMM + '-'+dateDD ;
    let MonthMM: string = this.nonCompliance.wpNonCompliance.nonCoopMonthDt['month'];
    if ( this.nonCompliance.wpNonCompliance.nonCoopMonthDt['month'] < 10) {
      MonthMM = '0' + this.nonCompliance.wpNonCompliance.nonCoopMonthDt['month'];
    }
    goodCausMonth=MonthMM+'/'+this.nonCompliance.wpNonCompliance.nonCoopMonthDt['year'];
    this.newTask.taskAdditionalInfo.discoveryDate=disDate;
    
    if(this.providerId !== undefined && this.providerId !== null ){
     this.newTask.assignedTo = this.serviceCountyForPerson.toString();
      this.newTask.assignedToInd = 'C';
      console.log("this.requestType create==="+this.requestType);
      if( this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'Y' ){
        if(this.requestType == 'Good Cause'){
        console.log("inside GR");
        this.newTask.taskType =  'GR' ; // GOOD CAUSE REQUEST
        this.newTask.taskAdditionalInfo.goodCauseMonth=goodCausMonth;
        this.newTask.taskAdditionalInfo.goodCauseReason=this.nonCompliance.wpNonCompliance.nonComplianceReasonCd;
        console.log("notes GR==="+this.nonCompliance.wpNonCompliance.nonComplianceNotes);
        this.newTask.taskAdditionalInfo.notes=this.nonCompliance.wpNonCompliance.nonComplianceNotes;

      }
        else if(this.requestType == 'Exemption'){
          this.newTask.taskType =  'EX' ; // GOOD CAUSE REQUEST
          this.newTask.taskAdditionalInfo.exemptionMonth=goodCausMonth;
          this.newTask.taskAdditionalInfo.exemptionReason=this.nonCompliance.wpNonCompliance.nonComplianceReasonCd;
          }

       }
      else if ( this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'N'){
        console.log("inside NC");
        this.newTask.taskType =  'NC' ; // NON COMPLIANCE
        this.newTask.taskAdditionalInfo.nonComplianceMonth=goodCausMonth;
        this.newTask.taskAdditionalInfo.nonComplianceReason=this.nonCompliance.wpNonCompliance.nonComplianceReasonCd;
        console.log("notes NC==="+this.nonCompliance.wpNonCompliance.nonComplianceNotes);
        this.newTask.taskAdditionalInfo.notes=this.nonCompliance.wpNonCompliance.nonComplianceNotes;

      }
    } else {
      // Close GR or NC
      this.completeTask();
      // Create new Task
      this.newTask.assignedTo = this.providerForPerson.toString();
      this.newTask.assignedToInd = 'P';
      if ( this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'Y' ){
        this.newTask.taskType =  'GD' ; // GOOD CAUSE DECISION
      }
      else if ( this.nonCompliance.wpNonCompliance.goodCauseRequestedSw === 'N'){
        this.newTask.taskType =  'ND' ;  // NON COMPLIANCE DECISION
      }
    }
    this.saveTask();
  }

  saveTask(){
    this.requestObject = Object.assign({}, this.newTask);
    
    this.http.post<Task>(this.ServerConstants.SERVER_API_URL + "/tasks/save", this.requestObject).subscribe(
      (val) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          console.log("taskType if==="+this.newTask.taskType);
          if(this.newTask.taskType === 'GR' || this.newTask.taskType === 'EX' || this.newTask.taskType === 'NC'){
          //this.notificationService.error('Create Task', this.userActionNotificationsMap.ERROR);
          this.notificationService.error('Unable to send task to the eligibility system; system will retry later.');              
          }  
        }
        else {
          this.requestObject = val;
          if (this.requestObject.id != null) {
            console.log("taskType else==="+this.newTask.taskType);
            //this.notificationService.success('Create Task', this.userActionNotificationsMap.UPDATE);
           // this.notificationService.success('Non-Compliance, Good Cause or Exemption details successfully sent to the eligibility system for processing');
           if(this.newTask.taskType === 'GR' || this.newTask.taskType === 'EX' || this.newTask.taskType === 'NC'){
           this.notificationService.success('Task successfully sent to the eligibility system for processing.');
            }
          }
        }
      },
      response => {
        //this.notificationService.error('Create Task', this.userActionNotificationsMap.ERROR);
        if(this.newTask.taskType === 'GR' || this.newTask.taskType === 'EX' || this.newTask.taskType === 'NC'){
          this.notificationService.error('Unable to send task to the eligibility system; system will retry later.');              
        } 
      },
    //   if (val == null || val.hasOwnProperty('errorCode')) {
    //     console.log("val null or error====");
    //     if (this.task.taskType === 'GR' || this.task.taskType === 'EX' || this.task.taskType === 'NC' 
    //    ) {    console.log("Unable to send task to the eligibility system if====");            
    //       this.notificationService.error('Task','Unable to send task to the eligibility system; system will retry later.');              
    //     } else {
    //       console.log("else ====");
    //       this.notificationService.error('Task', this.userActionNotificationsMap.ERROR);
    //     }
        

    //   } else {
    //     console.log("else 1====");
    //     this.task = val;
    //     console.log("this.task from val===="+this.task);
    //     if (this.task.id != null) {

    //       console.log("if 1 ====");

    //       // In case needs to update task
    //       this.dataService.addValueToSharedDataMap('task', this.task);
       

    //       if (this.task.taskType === 'GR' || this.task.taskType === 'EX' || this.task.taskType === 'NC'
    //           ) {
    //             console.log("Task successfully sent to the eligibility system");
    //         this.notificationService.success('Task successfully sent to the eligibility system for processing.', this.userActionNotificationsMap.UPDATE);
    //       } else {
    //         console.log("Task saved successfully");
    //         this.notificationService.success('Task saved successfully', this.userActionNotificationsMap.UPDATE);
    //       }
          
          

    //     }
    //   }
    // },
    // response => {
    //   this.notificationService.error('Create Task', this.userActionNotificationsMap.ERROR);
      
    // },
      () => {
      });
  }

  closeTask(){
    this.requestObject = Object.assign({}, this.cTask);
    //TODO: change to inprogress before close
    this.http.post<Task>(this.ServerConstants.SERVER_API_URL + "/taskManagement/closeTask", this.requestObject).subscribe(
      (val) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Task Completed', this.userActionNotificationsMap.ERROR);
        }
        else {
          //this.requestObject = val;
          //if (this.requestObject.id != null && this.requestObject.taskType === 'CO' ) {
          //  this.notificationService.success('Task Completed', this.userActionNotificationsMap.UPDATE);
          //}

        }
      },
      response => {
        this.notificationService.error('Task Completed', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  parseRefTableData(){
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.programs = this.data.getValueFromSharedDataMap("PROGRAMS");
    this.participationFailed = this.data.getValueFromSharedDataMap("failedToComplyNC");

    this.reasons = this.data.getValueFromSharedDataMap("goodCauseReason");
    this.nonComplianceReasonDesc = this.data.getValueFromSharedDataMap("NonCompReasonDesc");
    console.log(this.nonComplianceReasonDesc);
    this.nonComplianceReasonDesc.forEach((element)=>{
      this.requestReason.push(element);
    });
    this.verification = this.data.getValueFromSharedDataMap("GoodCauseReasonDesc")

    this.verificationMap = this.commonUtil.createMapFromList(this.verification );
    this.nonComplianceReasonDescMap = this.commonUtil.createMapFromList(this.nonComplianceReasonDesc );
  }

  convertCode(myMap, code){
    if(myMap != undefined){
      return myMap.get(code);
    }
  }

  goToNcSummary(){
    this.router.navigate(['task/noncomplianceSummary']);
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  enterKey() {
    var keyboardEvent = document.createEvent("KeyboardEvent");
    var initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? "initKeyboardEvent" : "initKeyEvent";
    keyboardEvent[initMethod](
      "keydown", // event type : keydown, keyup, keypress
      true, // bubbles
      true, // cancelable
      window, // viewArg: should be window
      false, // ctrlKeyArg
      false, // altKeyArg
      false, // shiftKeyArg
      false, // metaKeyArg
      13, // keyCodeArg : unsigned long the virtual key code, else 0
      0 // charCodeArgs : unsigned long the Unicode character associated with the depressed key, else 0
    );
    document.dispatchEvent(keyboardEvent);
  }
  createAlert(){
    let requestArray=[];
    let request = {
      createdBy: sessionStorage.getItem("FirstName"),
      description:"Your "+ this.requestType + " request has been " + this.data.getValueFromSharedDataMap("GoodCauseReasonDesc").find(obj => obj.value == this.nonCompliance.wpNonCompliance.grantGoodCauseCd).name,
      personId:Number(this.sharedData.get('wpPersonId'))
    }
    requestArray.push(request);
  this.http.post(this.ServerConstants.CITIZEN_API_URL+"/alerts/save",requestArray).subscribe((data)=>{
    if(data["message"]=="success" || data["code"]=="EENVELOPE"){
      this.saveDecision('Y');
      this.notificationService.success('Non-Compliance', "Alert Created for Citizen");
    }
    else{
      this.notificationService.error('Non-Compliance', "Unable to create alert for citizen");
    }
  },error=>{
    this.notificationService.error('Non-Compliance', "Unable to create alert for citizen");
  })
}
saveDecision(event){
    let request = {
      createdBy: sessionStorage.getItem("FirstName"),
      requestType:this.requestType,
      personId:Number(this.sharedData.get('wpPersonId')),
      dueDt:Number(this.data.getValueFromSharedDataMap("TASKDUEDATES").find(obj => obj.value == 'EX').name),
      grant:event
    }
    if(this.requestType == 'Good Cause' && (this.nonCompliance.wpNonCompliance.grantGoodCauseCd != null || this.nonCompliance.wpNonCompliance.grantGoodCauseCd != undefined)){
      console.log("Good Cause========");
      request.dueDt = Number(this.data.getValueFromSharedDataMap("TASKDUEDATES").find(obj => obj.value == 'DG').name)
    }
    if(this.requestType == 'Exemption' && this.requestedBy == 'Citizen'){
      console.log("Exemption======");
      request.requestType = 'Citizen Exemption';
    }
    console.log(request);
    console.log("request==="+request);
    this.http.post(this.ServerConstants.CITIZEN_API_URL+"/decision/save",request).subscribe((data)=>{
      if(data["message"]=="success"){
      }
      else{
        this.notificationService.error('Non-Compliance', "Unable to close citizen tasks");
      }
    },error=>{
      this.notificationService.error('Non-Compliance', "Unable to close citizen tasks");
    })
}
}


class GoodCauseVO {
  constructor(
    public etEnrollmentId ?: Number,
    public nonCoopMonthDt ?: any,
    public goodCauseAuthorizedCd ?: string,
  ) {
  }
}




// WEBPACK FOOTER //
// ./src/app/non-compliance/non-compliance.component.ts